import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  constructor(private httpClient: HttpClient) {}

  payBooking(data) {
    return this.httpClient.post(`${environment.apiUrl}/omisepay`, data);
  }

  payOrdering(data) {
    return this.httpClient.post(`${environment.apiUrl}/omisepayOrdering`, data);
  }
}
